var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1190_582)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8506 15.7879L19.879 18.8369L27.4501 11.722C28.2577 10.9089 27.7866 9.68929 27.4501 9.18111L26.9454 8.67342C26.1378 7.45379 24.5899 8.16524 23.917 8.67342L16.8506 15.7879Z",
    fill: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8696 19.8528L15.8411 16.8038L14.8316 17.8201L14.5625 21.2126L17.8601 20.8692L18.8696 19.8528Z",
    fill: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4689 24.2617H9.78472C8.00098 26 8.43875 26.9836 9.78472 28H29.4691C31.5011 26.5 30.6467 25.278 29.4689 24.2617Z",
    fill: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8506 15.7879L19.879 18.8369L27.4501 11.722C28.2577 10.9089 27.7866 9.68929 27.4501 9.18111L26.9454 8.67342C26.1378 7.45379 24.5899 8.16524 23.917 8.67342L16.8506 15.7879Z",
    stroke: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8696 19.8528L15.8411 16.8038L14.8316 17.8201L14.5625 21.2126L17.8601 20.8692L18.8696 19.8528Z",
    stroke: "#2f67ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4689 24.2617H9.78472C8.00098 26 8.43875 26.9836 9.78472 28H29.4691C31.5011 26.5 30.6467 25.278 29.4689 24.2617Z",
    stroke: "#2f67ca"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1190_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormEdit);
export default __webpack_public_path__ + "static/media/FormEdit.24e56e60b4e31a8ecbf22f88c10fba45.svg";
export { ForwardRef as ReactComponent };